// Privacy-friendly, cookieless analytics. No cookies, no persistent IDs,
// no third-party calls from the browser. Skips entirely for the admin
// (anyone with an admin token stored) and for Do-Not-Track browsers.
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let initialized = false;
let engagedMs = 0;
let lastVisible = null;

function shouldSkip() {
  try {
    if (localStorage.getItem("tico-admin-token")) return true;
  } catch (e) {
    // ignore
  }
  return navigator.doNotTrack === "1";
}

function send(payload) {
  try {
    fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "text/plain" }, // simple request, no preflight
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // ignore
  }
}

export function trackEvent(event, extra = {}) {
  if (shouldSkip()) return;
  send({ event, path: window.location.pathname, ...extra });
}

export function initAnalytics() {
  if (initialized || shouldSkip()) return;
  initialized = true;

  trackEvent("pageview", {
    referrer: document.referrer || "",
    sw: window.screen?.width || 0,
    lang: navigator.language || "",
  });

  lastVisible = document.visibilityState === "visible" ? Date.now() : null;

  const flush = () => {
    if (lastVisible) {
      engagedMs += Date.now() - lastVisible;
      lastVisible = document.visibilityState === "visible" ? Date.now() : null;
    }
    if (engagedMs >= 1000) {
      const dur = engagedMs;
      engagedMs = 0;
      send({ event: "engagement", path: window.location.pathname, duration_ms: dur });
    }
  };

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
    else lastVisible = Date.now();
  });
  window.addEventListener("pagehide", flush);
  setInterval(flush, 30000);

  // Outbound link clicks (Studio Nuts, LinkedIn, Behance, Instagram, ...)
  document.addEventListener("click", (e) => {
    const a = e.target.closest?.("a[href]");
    if (!a) return;
    const href = a.getAttribute("href") || "";
    if (/^https?:\/\//.test(href) && !href.includes(window.location.host)) {
      trackEvent("outbound", { target: href.slice(0, 300) });
    }
  });
}
